module.exports = __webpack_public_path__ + "img/default.a7b45b12.jpg";